import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';
import * as Types from 'js/components/main/BonusHistory/hooks/useTableData/types';

export const getFormattedData = () => (item: IBonusToDisplay) => {
    const bonusName = item.marketingName || item.templateName;

    return [
        {
            id: 0,
            value: item.playableGameTypes || item.isLoading || item.error
                ? { playableGameTypes: item.playableGameTypes, isLoading: item.isLoading, error: item.error }
                : null,
            type: Types.CELL_TYPE.GAMES
        },
        { id: 1, key: 'playtech.mobile.system.balance.waggerProgress', value: item.progressBarValue, type: Types.CELL_TYPE.PROGRESS_BAR },
        { id: 2, key: 'playtech.mobile.system.balance.expireDate', value: item.endDate, type: Types.CELL_TYPE.DEFAULT },
        { id: 3, key: 'playtech.mobile.system.balance.wagerRequirements', value: item.initialWagering, type: Types.CELL_TYPE.DEFAULT },
        { id: 4, key: 'playtech.mobile.system.balance.remainingToWager', value: item.wagering, type: Types.CELL_TYPE.DEFAULT },
        {
            id: 5,
            key: 'playtech.mobile.system.bonusDetail.tcTitle',
            value: item.popupWcId ? { popupWcId: item.popupWcId, popupTitle: item.popupTitle } : undefined,
            type: Types.CELL_TYPE.POPUP
        },
        {
            id: 6,
            key: 'playtech.mobile.system.bonusDetail.goldenChipsCountRemaining',
            value: item.isCancelButton
                ? { bonusName, bonusInstanceCode: item.bonusInstanceCode }
                : undefined,
            type: Types.CELL_TYPE.BUTTON
        }
    ] as Types.IAccordionRow[];
};
